import { render } from "./StudentsCreditsView.vue?vue&type=template&id=17bcc554&scoped=true"
import script from "./StudentsCreditsView.vue?vue&type=script&lang=js"
export * from "./StudentsCreditsView.vue?vue&type=script&lang=js"

import "./StudentsCreditsView.vue?vue&type=style&index=0&id=17bcc554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bcc554"]])

export default __exports__